document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.e-bw8-tabs-nav-item');
  const panes = document.querySelectorAll('.e-bw8-tab-pane');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      // Remove active class from all tabs and panes
      tabs.forEach(t => t.classList.remove('active'));
      panes.forEach(p => p.classList.remove('active'));

      // Add active class to the clicked tab and corresponding pane
      tab.classList.add('active');
      panes[index].classList.add('active');
    });
  });
});